import * as React from 'react';

import { debounce } from 'lodash';

/**
 * Create a debounced version of a value.
 *
 * WARNING: This hook is only for experimental purpose in `internal-enterprise`
 *          and should NOT be used by other bundles.
 *          If you have the needs, please consider using `use-debounce`
 *          (https://github.com/xnimorz/use-debounce).
 * Usage:
 *     const debouncedValue = useDebounce(value, 500);
 * @param value Value to be debounced.
 * @param delay delay in milliseconds.
 * @returns
 */
const useDebounce = <T>(value: T, delay: number) => {
  const [state, setState] = React.useState(value);

  // memoize the debounced callback to prevent debounce handler being recreated on every render
  // FIXME: existing react-hooks/exhaustive-deps violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounced = React.useCallback<(...args: $TSFixMe[]) => $TSFixMe>(debounce(setState, delay), [delay]); // create a debounced version of setState

  // Try to update the debounced value when value changes.
  React.useEffect(
    () => {
      debounced(value);
    }, // FIXME: existing react-hooks/exhaustive-deps violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value]
  );

  return state;
};

export default useDebounce;
